module.exports = __webpack_public_path__ + "img/careerclub.84021782.png";